var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HistoryToolService } from '../../../image-editor/history/history-tool.service';
import { OverlayPanelRef } from 'common/core/ui/overlay-panel/overlay-panel-ref';
import { Select } from '@ngxs/store';
import { HistoryState } from '../../state/history/history.state';
import { Observable } from 'rxjs';
var HistoryPanelComponent = /** @class */ (function () {
    function HistoryPanelComponent(history, panelRef) {
        this.history = history;
        this.panelRef = panelRef;
    }
    HistoryPanelComponent.prototype.loadHistoryState = function (item) {
        return this.history.load(item);
    };
    __decorate([
        Select(HistoryState.items),
        __metadata("design:type", Observable)
    ], HistoryPanelComponent.prototype, "items$", void 0);
    __decorate([
        Select(HistoryState.activeItemId),
        __metadata("design:type", Observable)
    ], HistoryPanelComponent.prototype, "activeItemId$", void 0);
    return HistoryPanelComponent;
}());
export { HistoryPanelComponent };
